var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.77 15.358L10 13.422l-3.77 1.936.721-4.104L3.88 8.33l4.244-.603L10 4.01l1.877 3.717 4.244.603-3.072 2.925.72 4.104zM10 11.666l1.687.866-.322-1.832 1.342-1.278-1.857-.263L10 7.475l-.85 1.684-1.857.263L8.635 10.7l-.322 1.832L10 11.666zM10 20a9.935 9.935 0 01-7.071-2.929A9.935 9.935 0 010 10a9.935 9.935 0 012.929-7.071A9.935 9.935 0 0110 0a9.935 9.935 0 017.071 2.929A9.935 9.935 0 0120 10a9.935 9.935 0 01-2.929 7.071A9.935 9.935 0 0110 20zm0-18.438c-4.652 0-8.438 3.786-8.438 8.438 0 4.652 3.786 8.438 8.438 8.438 4.652 0 8.438-3.786 8.438-8.438 0-4.652-3.786-8.438-8.438-8.438z",
    fill: "url(#best_svg__paint0_linear_6376_98388)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "best_svg__paint0_linear_6376_98388",
    x1: 10,
    y1: 0,
    x2: 10,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1393BC"
  })))));
}

export default __webpack_public_path__ + "./fonts/best.cd4fbcfcedb53c63a159888b71221026.svg";
export { SvgBest as ReactComponent };